export default __webpack_public_path__ + "static/media/ISCO CLASS-10_SYLLABUS_2025-26.4b062bd2.pdf";